import { createSelector } from '@reduxjs/toolkit'

import { getTotal as getTotalContactsCount } from 'common/audience/selectors/audienceSelectors'
import { getRootBillingState } from 'common/billing/entities/miscellaneous/selectors'
import { getTierByContacts } from 'common/billing/entities/tiers/helpers'
import { TierData } from 'common/billing/entities/tiers/interfaces'
import { DefaultModalState } from 'shared/lib/factory/redux/createModalSlice'

export const getTierLimitModalState = createSelector(
  (state: RootState): DefaultModalState => state.billing.tierLimitModal,
  (tierLimitModalState) => tierLimitModalState,
)

export const getTiersState = createSelector([getRootBillingState], (billing) => billing.tiers)

export const getTiersData = createSelector([getTiersState], (tiersState) => tiersState.tiers)

export const getCurrentTier = createSelector(
  [getTiersData, getTotalContactsCount],
  (tiers, contacts) => getTierByContacts(tiers, contacts),
)

export const getNextTier = createSelector(
  [getTiersData, getCurrentTier],
  (tiers, currentTier): TierData | null => {
    const currentIndex = tiers.findIndex((tier) => tier === currentTier)
    if (currentIndex === -1 || currentIndex === tiers.length - 1) {
      return null
    }
    return tiers[currentIndex + 1]
  },
)
